import WebService from '../../util/webService';
import constant from '../../util/constant';
import { setLoader } from "../actions/loaderActions";
import { setLocalData, getLocalData, removeLocalData } from '../../util/helper';
import Cookies from 'universal-cookie';

export const GET_SHOPIZER_CART_ID = "GET_SHOPIZER_CART_ID";
export const GET_CART = "GET_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";

const cartCookieName = () => window._env_.APP_MERCHANT + '_shopizer_cart';
const emptyCart = { code: '', products: [], quantity: 0, displaySubTotal: '¥0.00', displayTotal: '¥0.00' };

const messageOf = error => {
  const response = error && error.response && error.response.data;
  return (response && response.message) || "购物车操作失败，请稍后重试";
};

const storeCart = (dispatch, response) => {
  dispatch(setShopizerCartID(response.code));
  dispatch({ type: GET_CART, payload: response });
  return response;
};

export const acceptCartResponse = response => dispatch => storeCart(dispatch, response);

export const addToCart = (item, addToast, cartId, quantityCount, defaultStore, userData, selectedProductOptions) => {
  return async dispatch => {
    dispatch(setLoader(true));
    try {
      const param = selectedProductOptions !== undefined
        ? { attributes: selectedProductOptions, product: item.sku, quantity: quantityCount }
        : { product: item.sku, quantity: quantityCount };
      const effectiveCartId = !getLocalData('token') && cartId === 'MEMBER' ? null : cartId;
      let response;
      if (effectiveCartId) {
        const action = constant.ACTION.CART + encodeURIComponent(effectiveCartId)
          + '?store=' + window._env_.APP_MERCHANT;
        try {
          response = await WebService.put(action, param);
        } catch (error) {
          const status = error && error.response && error.response.status;
          if (getLocalData('token') || ![404, 409, 410].includes(status)) {
            throw error;
          }
          response = await WebService.post(constant.ACTION.CART + '?store=' + window._env_.APP_MERCHANT, param);
        }
      } else {
        response = await WebService.post(constant.ACTION.CART + '?store=' + window._env_.APP_MERCHANT, param);
      }
      storeCart(dispatch, response);
      if (addToast) {
        addToast(effectiveCartId ? "购物车已更新" : "商品已加入购物车", {
          appearance: "success",
          autoDismiss: true
        });
      }
      return response;
    } catch (error) {
      if (addToast) {
        addToast(messageOf(error), { appearance: "error", autoDismiss: true });
      }
      return null;
    } finally {
      dispatch(setLoader(false));
    }
  };
};

export const updateCartQuantity = (item, addToast, cartId, quantity, defaultStore) => {
  return async () => {
    try {
      const action = constant.ACTION.CART + encodeURIComponent(cartId)
        + '?store=' + (defaultStore || window._env_.APP_MERCHANT);
      return await WebService.put(action, { product: item.sku, quantity });
    } catch (error) {
      if (addToast) {
        addToast(messageOf(error), { appearance: "error", autoDismiss: true });
      }
      return null;
    }
  };
};

export const getCart = (cartID, userData) => {
  return async dispatch => {
    try {
      let action;
      if (getLocalData('token') || userData) {
        action = constant.ACTION.AUTH + constant.ACTION.CUSTOMER + constant.ACTION.CARTS;
        if (cartID && cartID !== 'MEMBER') {
          action += '?cart=' + encodeURIComponent(cartID);
        }
      } else if (cartID) {
        action = constant.ACTION.CART + encodeURIComponent(cartID);
      } else {
        dispatch({ type: GET_CART, payload: emptyCart });
        return emptyCart;
      }
      const response = await WebService.get(action);
      return storeCart(dispatch, response);
    } catch (error) {
      if (cartID && cartID !== 'MEMBER' && !getLocalData('token')) {
        try {
          const response = await WebService.get(constant.ACTION.CART + encodeURIComponent(cartID));
          return storeCart(dispatch, response);
        } catch (guestError) {
          console.log('Guest cart restore failed', guestError);
        }
      }
      console.log('Cart restore failed', error);
      return null;
    }
  };
};

export const setShopizerCartID = id => {
  const cookies = new Cookies();
  const cookieName = cartCookieName();
  if (id) {
    cookies.set(cookieName, id, { path: '/', maxAge: 15552000, sameSite: 'lax' });
    setLocalData(GET_SHOPIZER_CART_ID, id);
  } else {
    cookies.remove(cookieName, { path: '/' });
    removeLocalData(GET_SHOPIZER_CART_ID);
  }
  return dispatch => dispatch({ type: GET_SHOPIZER_CART_ID, payload: id || '' });
};

export const restoreCart = () => {
  return async dispatch => {
    const cookie = new Cookies().get(cartCookieName());
    if (cookie) {
      dispatch({ type: GET_SHOPIZER_CART_ID, payload: cookie });
    }
    return dispatch(getCart(cookie, null));
  };
};

export const getShopizerCartID = restoreCart;

export const decreaseQuantity = (item, addToast, cartId, quantityCount, defaultStore, userData) =>
  addToCart(item, addToast, cartId, quantityCount, defaultStore, userData);

export const increaseQuantity = (item, addToast, cartId, quantityCount, defaultStore, userData) =>
  addToCart(item, addToast, cartId, quantityCount, defaultStore, userData);

export const deleteFromCart = (cartID, item, defaultStore, addToast) => {
  return async dispatch => {
    dispatch(setLoader(true));
    try {
      const action = constant.ACTION.CART + encodeURIComponent(cartID) + '/' + constant.ACTION.PRODUCT
        + item.id + '?store=' + window._env_.APP_MERCHANT;
      const response = await WebService.delete(action);
      storeCart(dispatch, response);
      if (addToast) {
        addToast("商品已从购物车移除", { appearance: "success", autoDismiss: true });
      }
      return response;
    } catch (error) {
      if (addToast) {
        addToast(messageOf(error), { appearance: "error", autoDismiss: true });
      }
      return null;
    } finally {
      dispatch(setLoader(false));
    }
  };
};

export const clearCart = (cartID, addToast) => {
  return async dispatch => {
    dispatch(setLoader(true));
    try {
      const response = await WebService.delete(constant.ACTION.CART + encodeURIComponent(cartID));
      storeCart(dispatch, response);
      if (addToast) {
        addToast("购物车已清空", { appearance: "success", autoDismiss: true });
      }
      return response;
    } catch (error) {
      if (addToast) {
        addToast(messageOf(error), { appearance: "error", autoDismiss: true });
      }
      return null;
    } finally {
      dispatch(setLoader(false));
    }
  };
};

export const deleteAllFromCart = orderID => {
  return dispatch => dispatch({ type: DELETE_ALL_FROM_CART, payload: orderID });
};

export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  }
  return item.variation
    .filter(single => single.color === color)[0]
    .size.filter(single => single.name === size)[0].stock;
};
